import { Component, ViewChild } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { MenuComponent } from '../menu/menu.component';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { CommonModule } from '@angular/common';
import { AppInstallOverlayComponent } from 'src/app/shared/components/app-install-overlay/app-install-overlay.component';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  standalone: true,
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  imports: [OverlayPanelModule, CommonModule, SharedModule, MenuComponent]

})
export class NavbarComponent {
  @ViewChild('overlayRef') overlayRef!: OverlayPanel;
  @ViewChild('appInstall') appInstall!: AppInstallOverlayComponent;
  @ViewChild(MenuComponent) menuComponent!: MenuComponent; 

  currentPageTitle: string = 'Please check if all information is accurate';
  showShareOptions: boolean = false;

  constructor(
    private dialogService: DialogService,
    private router: Router
  ) {
    this.setupRouteListener();
  }

  private setupRouteListener() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updatePageTitle();
    });
  }

  private updatePageTitle() {
    const currentRoute = this.router.url;

    if (currentRoute.includes('/service-info') ||
      currentRoute.includes('/fee-breakdown') ||
      currentRoute.includes('/pickup-details')) {
      this.currentPageTitle = 'Please check if all information is accurate';
    }
    else if (currentRoute.includes('/payment-method')) {
      this.currentPageTitle = "You're almost there! Let's check those payment options and get you all set.";
    }
    else if (currentRoute.includes('/about')) {
      this.currentPageTitle = "Welcome! We're so glad to see you here";
    }
    else if (currentRoute.includes('/install-app')) {
      this.currentPageTitle = 'Make life easier right in the palm of your hands';
    }
    else {
      this.currentPageTitle = 'Please check if all information is accurate';
    }
  }

  openMenu(event: Event) {
    this.menuComponent.openMenu(event); 
  }

  navigateToAbout() {
    const urlSegments = this.router.url.split('/');
    const token = urlSegments[1];

    this.router.navigate([`/${token}/about`]);
  }

  openShareDialog() {
    this.appInstall.op.toggle(event); 
  }

  isPaymentPage(): boolean {
    return this.router.url.includes('/payment-method');
  }
  navigateToHome() {
    // Get the current token from the URL
    const urlSegments = this.router.url.split('/');
    const token = urlSegments[1]; // Assuming token is the first segment after base URL

    // Navigate to service-info with token
    this.router.navigate([`/${token}/service-info`]);
  }
  navigateToInstallApp() {
    const urlSegments = this.router.url.split('/');
    const token = urlSegments[1];

    this.router.navigate([`/${token}/install-app`]);
  }
}
